import { Breadcrumbs, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import BookComponent from '../../../components/bookComponent/BookComponent';
import SearchBook from '../../../components/SearchBook/SearchBook';
import Pagination from '../../../components/UI/pagination/Pagination';
import { useHistory, useLocation, Link } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import './style.css';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../Main';
// Removed StudentSubscription import

const Books = (props) => {
  const { isAuth } = useContext(AuthContext);
  const { t, i18n } = useTranslation();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [books, setBooks] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [categories, setCategories] = useState([]);
  const [queryType, setQueryType] = useState('');
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [perRow, setPerRow] = useState(6);
  let location = useLocation();
  let history = useHistory();

  useEffect(() => {
    const updatePerRow = () => {
      const w = window.innerWidth;
      if (w <= 768) setPerRow(2);
      else if (w <= 1100) setPerRow(4);
      else setPerRow(6);
    };
    updatePerRow();
    window.addEventListener('resize', updatePerRow);
    return () => window.removeEventListener('resize', updatePerRow);
  }, []);

  const getBooks = () => {
    setLoading(true);
    
    // Build query parameters
    let queryParams = `page=${page - 1}&limit=24&keyword=${keyword}`;
    
    // Only add queryType if it's not empty
    if (queryType) {
      queryParams += `&queryType=${queryType}`;
    }
    
    // Only add categories if there are any
    if (categories.length > 0) {
      queryParams += `&categories=${categories.join(',')}`;
    }
    
    const endpoint = isAuth ? '/book' : '/book/public';
    
    AxiosInstance.get(`${endpoint}?${queryParams}`)
      .then((response) => {
        // Sort books to show those with prices first
        const sortedBooks = response.data.items.sort((a, b) => {
          const aHasPrice = (a.price && a.price > 0) ? 1 : 0;
          const bHasPrice = (b.price && b.price > 0) ? 1 : 0;
          return bHasPrice - aHasPrice; // Books with prices first
        });
        setBooks(sortedBooks);
        setTotalPages(response.data.totalPages);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching books:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    let params = new URLSearchParams(props.location.search);
    setPage(params.get('page') ? params.get('page') : 1);
    if (params.get('queryType')) setQueryType(params.get('queryType'));
    else setQueryType('');
    if (params.get('keyword')) setKeyword(params.get('keyword'));
    if (params.get('categories')) setCategories(params.get('categories').split(','));
  }, [props.location.search]);

  useEffect(() => {
    let params = new URLSearchParams(props.location.search);
    if (
      ((params.get('queryType') && queryType) || (!params.get('queryType') && queryType === '')) &&
      ((params.get('keyword') && keyword) || (!params.get('keyword') && !keyword)) &&
      ((params.get('page') && page) || (!params.get('page') && page === 1)) &&
      ((params.get('categories') && categories.length) || (!params.get('categories') && !categories.length)) &&
      !ready
    ) {
      params.set('page', page);
      history.push({ search: params.toString() });
      getBooks();
      setReady(true);
    } else if (ready) {
      let checkIfParamsIsChanged = false;
      let pageChanged = false;
      const urlQueryType = params.get('queryType') || '';
      const urlKeyword = params.get('keyword') || '';
      const urlCategories = params.get('categories') || '';
      const stateCategories = categories.join(',');

      if (urlQueryType !== queryType) {
        pageChanged = true;
        if (queryType) {
          params.set('queryType', queryType);
        } else {
          params.delete('queryType');
        }
      } else if (urlKeyword !== keyword) {
        pageChanged = true;
        if (keyword) {
          params.set('keyword', keyword);
        } else {
          params.delete('keyword');
        }
      } else if (urlCategories !== stateCategories) {
        pageChanged = true;
        if (categories.length > 0) {
          params.set('categories', stateCategories);
        } else {
          params.delete('categories');
        }
      }

      if (String(params.get('page')) !== String(page) || pageChanged) {
        if (pageChanged) {
          setPage(1);
          params.set('page', 1);
        } else {
          params.set('page', page);
        }
        checkIfParamsIsChanged = true;
      }

      if (checkIfParamsIsChanged) {
        history.push({ search: params.toString() });
        getBooks();
      }
    }
  }, [page, keyword, categories, queryType]);

  useEffect(() => {
    const goToHome = () => {
      history.push('/');
    };
    return () => {
      if (history.action === 'POP') {
        goToHome();
      }
      window.removeEventListener('beforeunload', goToHome);
    };
  }, [history, location]);

  return (
    <div className="books-page">
      <SearchBook
        keyword={keyword}
        setKeyword={setKeyword}
        field={queryType}
        setField={setQueryType}
        categories={categories}
        setCategories={setCategories}
        onClick={getBooks}
      />
      <div className="books-page-inner">
        <nav className="bd-crumb" aria-label="breadcrumb">
          <Link to="/">{t('breadcrumb.home')}</Link>
          <span>/</span>
          {queryType ? (
            <>
              <Link to="/books">{t('breadcrumb.books')}</Link>
              <span>/</span>
              <span className="is-active">{t('breadcrumb.' + queryType)}</span>
            </>
          ) : (
            <span className="is-active">{t('breadcrumb.books')}</span>
          )}
        </nav>
      </div>
      {loading ? (
        <div className="no-item-container">
          <img src="/assets/images/loading.png" alt="no-item" className="no-item-image" />
          <div className="no-item-text">{t('loading')}</div>
        </div>
      ) : books.length ? (
        <div className="library-room">
          {Array.from({ length: Math.ceil(books.length / perRow) }, (_, row) => (
            <div className="shelf-row" key={`shelf-${row}`}>
              <div className="library-grid">
                {books.slice(row * perRow, row * perRow + perRow).map((book) => (
                  <div className="shelf-cell" key={book.id}>
                    <BookComponent data={book} variant="shelf" />
                  </div>
                ))}
              </div>
              <div className="shelf-plank" />
            </div>
          ))}
          <div className="books-list-pager">
            <Pagination page={page} setPage={setPage} totalPages={totalPages} />
          </div>
        </div>
      ) : (
        <div className="no-item-container">
          <img src="/assets/images/no-item.png" alt="no-item" className="no-item-image" />
          <div className="no-item-text">{t('no-item')}</div>
        </div>
      )}
      <div></div>
    </div>
  );
};

export default Books;
